import { type SearchRequest } from '@searchkit/api';
import { merge } from 'merge-anything';

import { createLocalDateRuntimeField, hitRateRequiredQueryFactory } from '~/search-domain/queries';
import { mergeQueries } from '~/search-domain/utils';
export function createQueryFactory(params: {
  activeSort: { field: string; order: 'asc' | 'desc' };
  hitRateBucket?: string;
  resultAttributes: string[];
  searchRequest: SearchRequest;
  timezone?: string;
}) {
  const { activeSort, hitRateBucket, resultAttributes, searchRequest, timezone } = params;
  const hitsPerPage = searchRequest.request.params?.hitsPerPage ?? 10;
  const page = searchRequest.request.params?.page ?? 0;
  const sort = { [activeSort.field]: activeSort.order };

  const bucketsNeeded = (page + 1) * hitsPerPage;

  const query = merge(searchRequest, {
    body: {
      aggs: {
        stable_total: { cardinality: { field: 'betId' } },
        bets_by_id: {
          terms: {
            field: 'betId',
            size: bucketsNeeded + 100, // Over-fetch to ensure we have enough after filtering
            order: { sort_value: activeSort.order },
          },
          aggs: {
            best_odds: {
              top_hits: {
                size: 1,
                sort: [{ oddsDecimal: 'desc' }],
                _source: { includes: resultAttributes },
              },
            },
            sort_value: { max: { field: activeSort.field } },
          },
        },
      },
      query: mergeQueries(
        searchRequest.body.query ?? {},
        ...(hitRateBucket ? [hitRateRequiredQueryFactory({ hitRateBucket })] : []),
      ),
      // Add runtime field for local date when timezone is specified (for date facet aggregation)
      ...(timezone && { runtime_mappings: createLocalDateRuntimeField(timezone) }),
      sort: [sort],
    },
  });

  return query;
}
